import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationSinistreChartComponent } from './classification-sinistre-chart.component';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule if ToastrService is used

@NgModule({
  declarations: [
    ClassificationSinistreChartComponent // Declare the ClassificationSinistreChartComponent
  ],
  imports: [
    CommonModule,                  // Import necessary Angular modules
    ToastrModule.forRoot()         // Include ToastrModule if ToastrService is used
  ],
  providers: [
    ChartConfigService             // Provide the ChartConfigService for dependency injection
  ],
  exports: [
    ClassificationSinistreChartComponent // Export the ClassificationSinistreChartComponent for use in other modules
  ]
})
export class ClassificationSinistreChartModule { }
